const COUNTRY_NAMES = {
    AT: 'Austria',
    CH: 'Switzerland',
    DE: 'Germany',
};

const PROVIDERS = {
    companyInfo: {
        id: 'company-info',
        name: 'Company Info',
        dataset: 'companyinfo.companyReport',
        icon: 'ri-building-2-line',
    },
    creditsafe: {
        id: 'creditsafe',
        name: 'Creditsafe',
        dataset: 'creditsafe.connect.company',
        icon: 'ri-shield-check-line',
    },
};

const REPORT_SECTIONS = [
    { key: 'company-information', title: 'Company Information' },
    { key: 'financial-summary', title: 'Financial Summary' },
    { key: 'management-team', title: 'Management Team' },
    { key: 'shareholders', title: 'Subcontractors' },
    { key: 'ultimate-shareholders', title: 'Ultimate Shareholders' },
    { key: 'subsidiaries', title: 'Subsidiaries' },
];

const COMPANY_FACTS = {
    1: {
        legalForm: 'AG',
        register: { court: 'Amtsgericht Bonn', number: 'HRB 6792', register: 'Handelsregister' },
        vatNumber: 'DE169838187',
        employees: 594000,
        industry: 'Postal and courier activities',
        nace: '53.10',
        signatoryRules: 'The company is represented by two members of the Board of Management or by one member together with an authorized officer.',
        management: [
            { name: 'Tobias Meyer', role: 'Chief Executive Officer', country: 'DE' },
            { name: 'Melanie Kreis', role: 'Chief Financial Officer', country: 'DE' },
        ],
        shareholders: [
            { name: 'Free float', type: 'Public', share: '79%' },
            { name: 'KfW Bankengruppe', type: 'Institution', share: '21%' },
        ],
        ultimateShareholders: [
            { name: 'Public shareholders', type: 'Listed company', share: '79%' },
            { name: 'Federal Republic of Germany (via KfW)', type: 'State-owned institution', share: '21%' },
        ],
        subsidiaries: [
            { name: 'DHL Express', country: 'DE', relation: 'Operating division' },
            { name: 'DHL Freight', country: 'DE', relation: 'Operating division' },
            { name: 'Deutsche Post AG', country: 'DE', relation: 'Parent legal entity' },
        ],
    },
    3: {
        legalForm: 'AG',
        register: { court: 'Handelsregisteramt Schwyz', number: 'CHE-102.270.313', register: 'UID' },
        vatNumber: 'CHE-102.270.313 MWST',
        employees: 79000,
        industry: 'Freight transport by road and contract logistics',
        nace: '49.41',
        signatoryRules: 'The company is represented by two members of the Management Board acting jointly.',
        management: [
            { name: 'Stefan Paul', role: 'Chief Executive Officer', country: 'CH' },
            { name: 'Markus Blanka-Graff', role: 'Chief Financial Officer', country: 'CH' },
        ],
        shareholders: [
            { name: 'Kuehne Holding AG', type: 'Company', share: '53%' },
            { name: 'Free float', type: 'Public', share: '47%' },
        ],
        ultimateShareholders: [
            { name: 'Klaus-Michael Kuehne', type: 'Individual', share: 'Controlling' },
        ],
        subsidiaries: [
            { name: 'Kuehne + Nagel AG', country: 'CH', relation: 'Operating company' },
            { name: 'Kuehne + Nagel (AG & Co.) KG', country: 'DE', relation: 'Subsidiary' },
        ],
    },
    4: {
        legalForm: 'SE',
        register: { court: 'Amtsgericht Kempten', number: 'HRB 14056', register: 'Handelsregister' },
        vatNumber: 'DE128644038',
        employees: 37000,
        industry: 'Road freight and groupage logistics',
        nace: '49.41',
        signatoryRules: 'The company is represented by two members of the Executive Board or by one member together with an authorized officer.',
        management: [
            { name: 'Burkhard Eling', role: 'Chief Executive Officer', country: 'DE' },
            { name: 'Stefan Hohm', role: 'Chief Development Officer', country: 'DE' },
        ],
        shareholders: [
            { name: 'Dachser family', type: 'Family', share: 'Private' },
        ],
        ultimateShareholders: [
            { name: 'Dachser family', type: 'Family', share: '100%' },
        ],
        subsidiaries: [
            { name: 'DACHSER SE', country: 'DE', relation: 'Parent company' },
            { name: 'DACHSER European Logistics', country: 'DE', relation: 'Business line' },
        ],
    },
    5: {
        legalForm: 'SE & Co. KG',
        register: { court: 'Amtsgericht Dortmund', number: 'HRA 17866', register: 'Handelsregister' },
        vatNumber: 'DE124086161',
        employees: 40000,
        industry: 'Contract logistics and road freight',
        nace: '52.29',
        signatoryRules: 'The general partner represents the company.',
        management: [
            { name: 'Tobias Bartz', role: 'Chief Executive Officer', country: 'DE' },
        ],
        shareholders: [
            { name: 'Rhenus family / holding', type: 'Family', share: 'Private' },
        ],
        ultimateShareholders: [
            { name: 'Rethmann Group', type: 'Company', share: '100%' },
        ],
        subsidiaries: [
            { name: 'Rhenus SE & Co. KG', country: 'DE', relation: 'Parent company' },
            { name: 'Rhenus Freight Logistics', country: 'DE', relation: 'Business line' },
        ],
    },
    6: {
        legalForm: 'AG',
        register: { court: 'Landesgericht Wiener Neustadt', number: 'FN 119594a', register: 'Firmenbuch' },
        vatNumber: 'ATU15349608',
        employees: 2200,
        industry: 'Full truckload road transport',
        nace: '49.41',
        signatoryRules: 'The company is represented by two members of the Management Board.',
        management: [
            { name: 'Executive Board', role: 'Management Board', country: 'AT' },
        ],
        shareholders: [
            { name: 'Walter family', type: 'Family', share: 'Private' },
        ],
        ultimateShareholders: [
            { name: 'Walter family', type: 'Family', share: '100%' },
        ],
        subsidiaries: [
            { name: 'LKW WALTER Internationale Transportorganisation AG', country: 'AT', relation: 'Parent company' },
        ],
    },
    7: {
        legalForm: 'GmbH',
        register: { court: 'Landesgericht Feldkirch', number: 'FN 59202k', register: 'Firmenbuch' },
        vatNumber: 'ATU36738508',
        employees: 8400,
        industry: 'Road freight and groupage',
        nace: '49.41',
        signatoryRules: 'The company is represented by two managing directors.',
        management: [
            { name: 'Wolfram Senger-Weiss', role: 'Chairman of the Management Board', country: 'AT' },
            { name: 'Jürgen Bauer', role: 'Member of the Management Board', country: 'AT' },
        ],
        shareholders: [
            { name: 'Weiss family', type: 'Family', share: 'Private' },
        ],
        ultimateShareholders: [
            { name: 'Weiss family', type: 'Family', share: '100%' },
        ],
        subsidiaries: [
            { name: 'Gebrüder Weiss Gesellschaft m.b.H.', country: 'AT', relation: 'Parent company' },
        ],
    },
    8: {
        legalForm: 'SE & Co. KG',
        register: { court: 'Amtsgericht Osnabrück', number: 'HRA 7908', register: 'Handelsregister' },
        vatNumber: 'DE117546869',
        employees: 16000,
        industry: 'Freight forwarding and logistics',
        nace: '52.29',
        signatoryRules: 'The general partner represents the company.',
        management: [
            { name: 'Reiner Heiken', role: 'Chief Executive Officer', country: 'DE' },
        ],
        shareholders: [
            { name: 'Hellmann family', type: 'Family', share: 'Private' },
        ],
        ultimateShareholders: [
            { name: 'Hellmann family', type: 'Family', share: '100%' },
        ],
        subsidiaries: [
            { name: 'Hellmann Worldwide Logistics SE & Co. KG', country: 'DE', relation: 'Parent company' },
        ],
    },
    9: {
        legalForm: 'Stiftung & Co. KG',
        register: { court: 'Amtsgericht Steinfurt', number: 'HRA 4846', register: 'Handelsregister' },
        vatNumber: 'DE125280514',
        employees: 23000,
        industry: 'Contract logistics',
        nace: '52.10',
        signatoryRules: 'The general partner represents the company.',
        management: [
            { name: 'Jens Fiege', role: 'Managing Partner', country: 'DE' },
            { name: 'Felix Fiege', role: 'Managing Partner', country: 'DE' },
        ],
        shareholders: [
            { name: 'Fiege family / foundation', type: 'Family', share: 'Private' },
        ],
        ultimateShareholders: [
            { name: 'Fiege family', type: 'Family', share: '100%' },
        ],
        subsidiaries: [
            { name: 'FIEGE Logistik Stiftung & Co. KG', country: 'DE', relation: 'Parent company' },
        ],
    },
};

const getLegalForm = (legalName) => {
    if (/SE\s*&\s*Co\.\s*KG/i.test(legalName)) return 'SE & Co. KG';
    if (/GmbH\s*&\s*Co\.\s*KG/i.test(legalName)) return 'GmbH & Co. KG';
    if (/Stiftung\s*&\s*Co\.\s*KG/i.test(legalName)) return 'Stiftung & Co. KG';
    if (/\bSE\b/.test(legalName)) return 'SE';
    if (/\bAG\b/.test(legalName)) return 'AG';
    if (/GmbH|Gesellschaft m\.b\.H/i.test(legalName)) return 'GmbH';
    if (/\bKG\b/.test(legalName)) return 'KG';

    return 'Company';
};

const nameFromEmail = (email) => (
    email
        .split('@')[0]
        .split(/[._-]/)
        .filter(Boolean)
        .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
        .join(' ')
);

const formatRevenue = (millionEur) => {
    if (!millionEur) return '—';

    return new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        maximumFractionDigits: 0,
    }).format(millionEur * 1000000);
};

const addDays = (isoDate, days) => {
    const date = new Date(`${isoDate}T00:00:00Z`);

    date.setUTCDate(date.getUTCDate() + days);

    return date.toISOString().slice(0, 10);
};

const createCompanyIdentity = (carrier, publicProfile) => {
    const facts = COMPANY_FACTS[carrier.id] || {};
    const legalName = publicProfile?.legalName || carrier.name;
    const countryName = COUNTRY_NAMES[carrier.country] || carrier.countryName;
    const website = publicProfile?.website || carrier.website;
    const address = publicProfile?.address || `${carrier.headquarters}, ${countryName}`;
    const contactPeople = (carrier.contacts || [])
        .filter((contact) => contact.email)
        .map((contact) => ({
            name: nameFromEmail(contact.email),
            role: 'Listed contact',
            country: carrier.country,
        }));

    return {
        address,
        country: carrier.country,
        countryName,
        email: publicProfile?.email || carrier.contacts?.[0]?.email || '—',
        employees: facts.employees || null,
        established: publicProfile?.established || null,
        headquarters: carrier.headquarters,
        industry: facts.industry || carrier.roadCargoFocus,
        legalForm: facts.legalForm || getLegalForm(legalName),
        legalName,
        legalStatus: 'Active',
        nace: facts.nace || '—',
        phone: publicProfile?.phone || '—',
        register: facts.register || { court: '—', number: '—', register: '—' },
        revenue: formatRevenue(carrier.estimatedRevenueMillionEur),
        revenueMillionEur: carrier.estimatedRevenueMillionEur,
        shortName: carrier.name,
        signatoryRules: facts.signatoryRules || '—',
        vatNumber: facts.vatNumber || '—',
        website,
        websiteUrl: /^[a-z0-9.-]+\.[a-z]{2,}$/i.test(website) ? `https://${website}` : null,
        management: facts.management || contactPeople,
        shareholders: facts.shareholders || [],
        ultimateShareholders: facts.ultimateShareholders || [],
        subsidiaries: facts.subsidiaries || [],
    };
};

const createReport = ({
    carrier,
    identity,
    provider,
    fetchedOn,
    sections,
}) => ({
    id: `${carrier.id}-${provider.id}`,
    companyName: identity.legalName,
    shortName: identity.shortName,
    dataset: provider.dataset,
    fetchedOn,
    provider: provider.name,
    providerIcon: provider.icon,
    identity,
    sections,
});

const createCompanyReports = (carrier, publicProfile) => {
    const identity = createCompanyIdentity(carrier, publicProfile);
    const companyInfoReport = createReport({
        carrier,
        fetchedOn: addDays(carrier.addedOn || '2025-04-15', 3),
        identity,
        provider: PROVIDERS.companyInfo,
        sections: REPORT_SECTIONS,
    });

    if (!COMPANY_FACTS[carrier.id]) {
        return [companyInfoReport];
    }

    return [
        companyInfoReport,
        createReport({
            carrier,
            fetchedOn: addDays(carrier.addedOn || '2025-04-15', 10),
            identity,
            provider: PROVIDERS.creditsafe,
            sections: REPORT_SECTIONS.slice(0, 3),
        }),
    ];
};

export default createCompanyReports;
